<template>
  <div class="payment-info-box">
    <div class="bank_promotion_banner mb-3" v-if="customerData?.merchantProductPromotionDetail?.merchantProductPromotionUrl ">
      <img class="bank_banner_image" :src="customerData?.merchantProductPromotionDetail?.merchantProductPromotionUrl"/>
    </div>
    <div class="payment-info-wrap">
        <h4 class="detail-title">Payment Request from {{ customerData.merchantDetail.companyName }}</h4>
        <div class="detail-row">
            <h6>PAYMENT FOR</h6>
            <p v-if="customerData.customerPaymentDetail.remarks != null">{{ customerData.customerPaymentDetail.remarks }}</p>
        </div>
        <div class="detail-row">
            <h6>ISSUED TO</h6>
            <p>
                <span class="d-block">{{ customerData.customerPaymentDetail.fullName }}</span>
                <span class="d-block">{{ customerData.customerPaymentDetail.email }}</span>
            </p>
        </div>
        <div class="detail-row">
            <h6>AMOUNT PAYABLE</h6>
            <h2 class="payable-amount">
              {{ formatCurrency(customerData) }}
            </h2>
        </div>
    </div>
    <div class="merchant_promotion_banner mt-3 mb-2" v-if="customerData?.merchantProductPromotionDetail?.bankProductPromotionUrl">
      <img class="merchant_banner_image" :src="customerData?.merchantProductPromotionDetail?.bankProductPromotionUrl"/>
    </div>
  </div>
</template>
<script>

import { formatCurrency } from '../../../lib/currency'

export default {
  name: "PaymentInfoBox",
  props: {
    customerData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    formatCurrency
  }
};
</script>
<style scoped>
.bank_promotion_banner, .merchant_promotion_banner {
  width: 100%;
  height: 150px;
  max-height: 150px;
}
.bank_banner_image,  .merchant_banner_image {
  max-height: 150px;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
}
</style>